<template>
  <div class="balanceRecord">
    <div class="custom-breadcrumbs">
      <i class="el-icon-arrow-left icon-back" @click="onClickBack('Financial_Manage_Balance')" />
      <span class="first-span" @click="onClickBack('Financial_Manage_Balance')">{{ $t('data.balance_details') }}</span>
    </div>
    <div class="filter-container">
      <span class="transTime">{{ $t('merchantAccount.balance_record_type') }}:</span>
      <el-select
        v-model="search.balance_type"
        size="small"
        :placeholder="$t('merchantAccount.balance_record_type')"
        class="search-frame provisions-bank provisions-frame"
        clearable
      >
        <el-option
          v-for="(item,index) in balanceTypeArr"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <span class="transTime">{{ $t('components.date') }}:</span>
      <!-- 时间 -->
      <el-date-picker
        v-model="search.times"
        class="mb-10 picker"
        size="small"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00','23:59:59']"
        type="daterange"
        range-separator="~"
        :start-placeholder="$t('components.start_date')"
        :end-placeholder="$t('components.end_date')"
      />
      <!-- 查询 -->
      <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
      <!-- 明细excel下载 -->
      <el-button class="mb-10 download-btn" type="info" size="small" :disabled="downloading" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >
        <!--        <el-table-column label="ID" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--            {{ scope.row.id }}-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column :label="$t('merchantAccount.init_balance')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.init_balance | toDivideWithDot }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('merchantAccount.current_balance')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.balance | toDivideWithDot }}</span>
          </template>
        </el-table-column>
        <!--
        <el-table-column :label="$t('merchantAccount.in_transit_settlement_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.fund_settlement_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('components.amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.balance_change_amount | toDivideWithDot }}</span>
            <!-- 支付后退款及支付后退款失败的变动流水金额处，增加问号提示语 -->
            <el-tooltip v-if="[19,20].includes(scope.row.balance_type)">
              <div slot="content">
                <span> {{ $t('tips.balance_change_amount_tip') }}</span> <br>
              </div>
              <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.type')" align="center">
          <template slot-scope="scope">
            <span>{{ getcreditDebitTypeLabel(scope.row.type) }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.balance_record_type')" width="200" align="center">
          <template slot-scope="scope">
            <el-tag style="color: #FFFFFF" :color="getBalanceColorStyle(scope.row.balance_type)" :type="getBalanceTypeStyle(scope.row.balance_type)">{{ getBalanceTypeMap(scope.row.balance_type) }}</el-tag>
            <span />
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.create_time')" align="center" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>

        <!-- <el-table-column :label="$t('merchantAccount.update_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.update_time }}</span>
          </template>
        </el-table-column> -->

        <el-table-column :label="$t('merchantAccount.note')" align="center">
          <template slot-scope="scope">
            <span :class="{ 'nsds-recycle-remark': isNsdsCreditRecycle(scope.row) }">{{ formatRemark(scope.row) }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>

  </div>
</template>

<script>

import { fetchMchBalanceInfo, fetchMchBalanceInfoAllList } from '@/api/settlement/settlement'
import { balanceTypeMap, creditDebitType } from '@/utils/maps'
import { filterEmptyAttr, exportXlsxFitWidth } from '@/utils/common'
import { appointDate } from '@/utils/index.js'

export default {
  name: 'Balance_Trans_Detail',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      search: {
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59']
      },
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    balanceTypeArr() {
      let list = balanceTypeMap()
      if (this.relatedMerchantsList <= 0 && !this.$store.getters.isPlatformRelateMerchant) {
        list = list.filter(item => ![6, 7].includes(item.value))
      }
      return list
    },
    getBalanceTypeMap() {
      return function(value) {
        return balanceTypeMap(value).label
      }
    },
    getBalanceTypeStyle() {
      return function(value) {
        return balanceTypeMap(value).type
      }
    },
    getBalanceColorStyle() {
      return function(value) {
        return balanceTypeMap(value).color
      }
    },
    getcreditDebitTypeLabel() {
      return function(value) {
        return creditDebitType(value).label
      }
    }
  },
  created() {
    this.handleFilter()
  },
  methods: {
    getMchBalanceInfo(data) {
      this.listLoading = true
      fetchMchBalanceInfo(data).then(res => {
        const { total, list = [] } = res.data
        this.listQuery.total = total
        this.listQuery.page = data.page ? data.page : 1
        this.tableData = list
        // this.refundPopArr = Array(res.data.list.length).fill({ refundTxt: 'ddd', refundPopVisible: false })
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { times = [], ...otherSearch } = this.search
      let params = { start_date_time: times && times[0], end_date_time: times && times[1], ...otherParams, ...otherSearch }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.getMchBalanceInfo(params)
    },

    onClickDowmloadBtn() {
      const params = this.getParams()
      this.downloading = true
      fetchMchBalanceInfoAllList(params).then(res => {
        this.$message.success('Start downloading!')
        this.handleXlsxData(res.data).then((downloadData) => {
          exportXlsxFitWidth(downloadData, 'Balance_Record')
        })
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('merchantAccount.init_balance'),
        this.$t('merchantAccount.current_balance'),
        this.$t('merchantAccount.amount'),
        this.$t('components.type'),
        this.$t('merchantAccount.balance_record_type'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.note')
      ]]

      const toDivideWithDot = this.$options.filters['toDivideWithDot']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            toDivideWithDot(tr.init_balance),
            toDivideWithDot(tr.balance),
            toDivideWithDot(tr.balance_change_amount),
            this.getcreditDebitTypeLabel(tr.type),
            this.getBalanceTypeMap(tr.balance_type),
            tr.create_time,
            this.formatRemark(tr)
          ])
        })
      }
      return Promise.resolve(rows)
    },

    onClickPaginator() {
      this.handleFilter(this.listQuery)
    },
    isNsdsCreditRecycle(row = {}) {
      return Number(row.balance_type) === 38
    },
    formatRemark(row = {}) {
      return this.isNsdsCreditRecycle(row) ? this.$t('tips.nsds_credit_recycle_remark') : row.remark
    },
    onClickBack(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-breadcrumbs{
  display: flex;
  justify-items: center;
  margin: 32px 0;
  color: #3855F1;
  cursor: pointer;
  .icon-back{
    position: relative;
    top: -1px;
    margin-right: 12px;
    margin-top: 2px;
  }
}
.balanceRecord{
  background-color: #fff;
  margin: 20px;
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    text-align: right;
    padding-bottom: 22px;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
  .icon-question{
    font-size: 11px;
    position: relative;
    top: -1px;
    left: 2px;
    cursor: pointer;
  }
  .nsds-recycle-remark {
    color: #F56C6C;
  }
}

</style>
